/**
 * Sizing options for SBAvatarImage
 */

const SBAvatarImageSize = {
  W16: 'w16',
  W18: 'w18',
  W20: 'w20',
  W30: 'w30',
  W68: 'w68',
};

export default SBAvatarImageSize;
